module.exports = __webpack_public_path__ + "img/progateNodeJS.4866fd4c.webp";